import appParameters from './AppParameters';
import storeManager from '../../store/StoreManager';
import { addSoundClipartModel } from '../../actions/MusicActions';

const audioClipartModel = {
    subcategories: [0, 0, 0],

    addToStateAudioClipart() {
        var href = appParameters.clipartBucket() + '/audioeditor/audioThree.json?cache=' + Math.random();

        try {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', href, true);

            xhr.onload = function () {
                this.appendToState(xhr.response);
            }.bind(this);

            xhr.send();
        } catch(err) {
            console.log('Error ' + err);
        }
    },
    appendToState(data) {
        var data = this.parseData(JSON.parse(data));
        const store = storeManager.getStore();

        store.dispatch(addSoundClipartModel(data));
    },
    parseData(data) {
        let categories = data.categories;
        let newCategories = [];

        for (let i = 0; i < categories.length; i++) {
            let themes = categories[i].themes;
            let newThemes = [];

            for (let j = 0; j < themes.length; j++) {
                let tracks = themes[j].tracks;
                let newTracks = [];

                for (let k = 0; k < tracks.length; k++) {
                    let element = {};

                    element.title = this.getCorrectTitle(tracks[k].track_title);
                    element.duration = tracks[k].duration;
                    element.href = tracks[k].href;
                    element.contentType = 'content_sound';
                    element.contentItemId = -1;

                    newTracks.push(element);
                }

                let themesElement = {};
                themesElement.title = this.getCorrectTitle(themes[j].theme_title);
                themesElement.items = newTracks;

                newThemes.push(themesElement);
            }

            let categoryElement = {};
            categoryElement.title = this.getCorrectTitle(categories[i].category_title);
            categoryElement.items = newThemes;

            newCategories.push(categoryElement);
        }

        let newData = {};
        newData.title = data.sound_library_title;
        newData.items = newCategories;

        return newData;
    },
    getCorrectTitle(item) {
        let title = '';

        switch (appParameters.locale) {
            case 'en_US': {
                title = item.us_EN;
                break;
            }
            case 'sv_SE': {
                title = item.sv_SV;
                break;
            }
            case 'nb_NO': {
                title = item.nb_NO;
                break;
            }
            case 'nn_NO': {
                title = item.nn_NO;

                if (!title || title === '')
                    title = item.nb_NO;
                break;
            }
        }

        if (!title || title === '')
            title = item.us_EN;

        return title;
    }
};

export default audioClipartModel;



/** WEBPACK FOOTER **
 ** ./src/components/utils/AudioClipartModel.js
 **/